module.exports = __webpack_public_path__ + "static/media/Bg3.f65ac3b7.svg";